import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_td = _resolveComponent("q-td")!
  const _component_view_search_btn = _resolveComponent("view-search-btn")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_humanize_time = _resolveComponent("humanize-time")!
  const _component_edit_search_btn = _resolveComponent("edit-search-btn")!
  const _component_export_to_report_modal_btn = _resolveComponent("export-to-report-modal-btn")!
  const _component_delete_search_btn = _resolveComponent("delete-search-btn")!
  const _component_message = _resolveComponent("message")!
  const _component_q_table = _resolveComponent("q-table")!

  return (_openBlock(), _createBlock(_component_q_table, {
    columns: _ctx.columns,
    rows: _ctx.postSearches,
    loading: _ctx.isLoading,
    pagination: _ctx.pagination,
    "onUpdate:pagination": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.pagination) = $event)),
    "wrap-cells": "",
    onRequest: _cache[1] || (_cache[1] = ($event: any) => (_ctx.pagination = $event.pagination))
  }, {
    "body-cell-keywords": _withCtx((props) => [
      _createVNode(_component_q_td, { props: props }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$filters.keywords(props.row.keywords)), 1)
        ]),
        _: 2
      }, 1032, ["props"])
    ]),
    "body-cell-matches": _withCtx((props) => [
      _createVNode(_component_q_td, { props: props }, {
        default: _withCtx(() => [
          _createVNode(_component_view_search_btn, {
            "post-search": props.row,
            "onUpdate:postSearch": _ctx.set
          }, null, 8, ["post-search", "onUpdate:postSearch"])
        ]),
        _: 2
      }, 1032, ["props"])
    ]),
    "body-cell-creator": _withCtx((props) => [
      _createVNode(_component_q_td, { props: props }, {
        default: _withCtx(() => [
          _createVNode(_component_q_icon, { name: "fa fa-user" }),
          (props.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(props.value.firstName) + " " + _toDisplayString(props.value.lastName), 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_2, " N/A "))
        ]),
        _: 2
      }, 1032, ["props"])
    ]),
    "body-cell-createdAt": _withCtx((props) => [
      _createVNode(_component_q_td, { props: props }, {
        default: _withCtx(() => [
          _createVNode(_component_humanize_time, {
            time: props.value
          }, null, 8, ["time"])
        ]),
        _: 2
      }, 1032, ["props"])
    ]),
    "body-cell-actions": _withCtx((props) => [
      _createVNode(_component_q_td, { props: props }, {
        default: _withCtx(() => [
          _createVNode(_component_edit_search_btn, {
            "post-search-id": props.row.id,
            class: "on-left",
            round: "",
            flat: "",
            onEdited: _ctx.set
          }, null, 8, ["post-search-id", "onEdited"]),
          _createVNode(_component_export_to_report_modal_btn, {
            "post-search-id": props.row.id,
            class: "on-left"
          }, null, 8, ["post-search-id"]),
          _createVNode(_component_delete_search_btn, {
            "post-search": props.row,
            round: "",
            flat: "",
            onDeleted: _ctx.load
          }, null, 8, ["post-search", "onDeleted"])
        ]),
        _: 2
      }, 1032, ["props"])
    ]),
    "no-data": _withCtx(() => [
      _createVNode(_component_message, {
        type: "info",
        class: "full-width q-my-sm",
        style: {"font-size":".9rem"}
      }, {
        default: _withCtx(() => [
          _createTextVNode(" No searches found. ")
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["columns", "rows", "loading", "pagination"]))
}